import { gql } from "@apollo/client";

export const GET_PERMISO_NUEVA_VISITA = gql`
query GetPermisoNuevaVisitaControl($input: PermisoVisitaCoordinadorInput!) {
    permisoNuevaVisitaControl(input: $input)
}`;